import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-vp_live",
  "use": "n-icon-vp_live-usage",
  "viewBox": "0 0 32 20",
  "content": "<symbol viewBox=\"0 0 32 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-vp_live\">\n<path d=\"M1.32568 15H7.91748V13.5864H2.96631V4.43115H1.32568V15ZM9.75756 15H11.3982V4.43115H9.75756V15ZM16.7612 15H18.5703L22.3349 4.43115H20.5552L17.728 13.0225H17.6035L14.7763 4.43115H12.9966L16.7612 15ZM23.9406 15H30.6496V13.5864H25.5813V10.2979H30.3786V8.93555H25.5813V5.84473H30.6496V4.43115H23.9406V15Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol